var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 77,
    viewBox: "0 0 99 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97644 59.5476L20.2158 44.3082C21.8888 42.6331 24.1585 41.691 26.5259 41.6889H34.7408C36.3196 41.6889 37.8338 42.3161 38.9502 43.4325C40.0665 44.5489 40.6937 46.063 40.6937 47.6418C40.6937 49.2206 40.0665 50.7347 38.9502 51.8511C37.8338 52.9675 36.3196 53.5947 34.7408 53.5947H27.2997M39.2055 51.5707L51.6173 37.0159C52.5762 35.953 53.906 35.298 55.3331 35.1857C56.7602 35.0734 58.1761 35.5123 59.2894 36.4122C60.4028 37.312 61.1289 38.6043 61.3185 40.0232C61.508 41.4422 61.1466 42.8798 60.3085 44.0403L47.8074 61.7204C46.989 62.8799 45.906 63.8276 44.6481 64.485C43.3903 65.1424 41.9939 65.4905 40.5747 65.5004H25.3055C24.52 65.4998 23.7421 65.6547 23.0167 65.9561C22.2913 66.2574 21.6328 66.6994 21.079 67.2565L16.8822 71.4533M2 56.5711L19.8586 74.4298",
    stroke: "url(#paint0_linear_3_826)",
    strokeWidth: 5.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1097 17.3119L78.8704 32.5513C77.1974 34.2264 74.9277 35.1685 72.5603 35.1706H64.3453C62.7665 35.1706 61.2524 34.5434 60.136 33.427C59.0196 32.3106 58.3925 30.7965 58.3925 29.2177C58.3925 27.6389 59.0196 26.1248 60.136 25.0084C61.2524 23.892 62.7665 23.2648 64.3453 23.2648H71.7864M59.8807 25.2888L47.4689 39.8436C46.51 40.9065 45.1802 41.5615 43.7531 41.6738C42.326 41.7861 40.9101 41.3472 39.7967 40.4473C38.6834 39.5475 37.9572 38.2552 37.7677 36.8363C37.5781 35.4173 37.9396 33.9797 38.7777 32.8192L51.2788 15.1391C52.0972 13.9796 53.1802 13.0319 54.438 12.3745C55.6959 11.7171 57.0923 11.369 58.5115 11.3591H73.7807C74.5662 11.3597 75.344 11.2048 76.0694 10.9034C76.7948 10.602 77.4534 10.1601 78.0072 9.60297L82.204 5.40619M97.0862 20.2884L79.2275 2.42975",
    stroke: "url(#paint1_linear_3_826)",
    strokeWidth: 5.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_826",
    x1: 31.6839,
    y1: 35.1685,
    x2: 31.6839,
    y2: 74.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_826",
    x1: 67.4023,
    y1: 41.691,
    x2: 67.4023,
    y2: 2.42974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.c953a35a7f8b24a0349dc2f4a05ecf38.svg";
export { ForwardRef as ReactComponent };